export default __webpack_public_path__ + "static/EverydayBannerMob-51aa974c1bd35164cdeabd6a47a2f389.png";